import { Sparkles } from "lucide-react";
import { useTheme } from '@/contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import AnimatedBorderBadge from './AnimatedBorderBadge';

const EditorialTrialCTA = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  
  const headingColor = theme === 'dark' ? '#FFFFFF' : '#111111';
  const textColor = theme === 'dark' ? '#AAAAAA' : '#555555';
  const borderColor = theme === 'dark' ? '#333333' : '#E0E0E0';
  const cardBgColor = theme === 'dark' ? '#222222' : '#f4f2f1';
  const sectionBgColor = theme === 'dark' ? '#111111' : '#FFFFFF';

  return (
    <section
      className="w-full py-16 px-[7%] sm:px-6 transition-colors duration-300"
      style={{ backgroundColor: sectionBgColor }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8">
          <div className="lg:flex-1">
            <AnimatedBorderBadge text="All-in-one" icon={Sparkles} align="left" />
            <h2 className="text-3xl lg:text-4xl font-bold mb-4 tracking-tight" style={{ color: headingColor }}>
              Start Your 14 Day Free Trial.
            </h2>
            <p className="text-sm mb-6 max-w-2xl" style={{ color: textColor }}>
              The first two weeks are on us. Stop the lead bleed today.
            </p>
            <button 
              onClick={() => navigate('/pricing#pricing-section')}
              className="w-[140px] px-4 py-2 text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 rounded-lg hover:scale-[1.02] hover:shadow-md active:scale-[0.98] hover:opacity-90"
              style={{ backgroundColor: theme === 'dark' ? '#FFFFFF' : 'black', color: theme === 'dark' ? '#000000' : 'white' }}
            >
              Start for free →
            </button>
          </div>
          <div className="flex flex-row gap-3 lg:mt-6">
            {[{ value: 'Free', label: 'CRM migration (worth $995)' }, { value: '1:1', label: 'onboarding sessions' }, { value: '10', label: 'weeks group training' }].map((stat, i) => (
              <div key={i} className="rounded-xl p-4 w-32 transition-all duration-200 hover:scale-105 cursor-pointer" style={{ backgroundColor: cardBgColor, border: `1px solid ${borderColor}`, boxShadow: '0 15px 30px -8px rgba(0, 0, 0, 0.12)' }}>
                <div className="text-xl lg:text-2xl font-bold mb-0.5" style={{ color: headingColor }}>{stat.value}</div>
                <div className="text-xs" style={{ color: textColor }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorialTrialCTA;
